import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import defaultLayout from "./layout/default.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: defaultLayout,
      children: [
        {
          path: "",
          name: "index",
          component: () =>
            import(/* webpackChunkName: "exchange/pages/index" */ "@/frontend/exchange/pages/index.vue"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: "wallet-history",
          path: "account/wallet-history",
          component: () =>
            import(/* webpackChunkName: "pages/account/wallet-history" */ "@/frontend/account/pages/walletHistory.vue"),
          meta: {
            requiresAuth: true,
            searchContext: "ACCOUNT",
          },
        },
        {
          path: "signin",
          name: "signin",
          component: () =>
            import(/* webpackChunkName: "pages/signin" */ "@/frontend/pages/signin.vue"),
          props: {
            viewOtherLink: false,
            viewCreateAccountLink: false,
          },
        },
      ],
    },
  ],
});

export default router;

router.beforeEach(async (to, from, next) => {
  next();
});
